/* eslint-disable no-console */
/* eslint-disable func-names */
export default function register() {
  if (process.env.NODE_ENV === 'production') {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', function () {
        navigator.serviceWorker
          .register('/svcWorker.js', { scope: '/' })
          .then(
            function (registration) {
              console.log(
                'Worker registration is successful',
                registration.scope,
              );
            },
            function (err) {
              console.log('Worker registration has failed', err);
            },
          )
          .catch(function (err) {
            console.log(err);
          });
      });
    } else {
      console.log('Service Worker is not supported by your browser.');
    }
  }
}
